/*
 * Payment methods the admin enabled (`GET /settings/payment-methods`), in
 * admin order. One request per page load, shared by the footer and the
 * "how it works" tile. Empty until loaded or when the request fails — the
 * callers render nothing rather than a hardcoded list.
 */
import { ref } from 'vue';
import { api } from '../api/client';

export interface PaymentMethod {
  slug: string;
  name: string;
  icon?: string;
}

const methods = ref<PaymentMethod[]>([]);
let fetching: Promise<void> | null = null;

export function usePaymentMethods() {
  fetching ??= api
    .get<PaymentMethod[]>('/settings/payment-methods')
    .then(({ data }) => {
      methods.value = data;
    })
    .catch(() => {
      fetching = null;
    });
  return { methods };
}
